import moment from "moment";
import { useIntl } from "react-intl";
import { Constants } from "../../../constants";
import { EcgsFilters } from "../../Shared/EcgsFilter/EcgsFilter";

import styles from "./FiltersDescription.module.css";

const FiltersDescription = ({
  fromDate,
  toDate,
  sn,
  reviewPriorityHigh,
  reviewPriorityLow,
  reviewPriorityNone,
  unInterpretedOnly,
  unviewedOnly,
  includeArchived,
}: EcgsFilters) => {
  const intl = useIntl();

  let filtersDescription: string[] = [];

  if (fromDate || toDate) {
    let dateText = "";

    if (fromDate) {
      const fromTranslated = intl.messages["ECGS_FILTER.DATE.FROM"] as string;
      dateText += `${fromTranslated} ${moment(fromDate).format(
        Constants.SECONDARY_DATE_FORMAT
      )}`.toUpperCase();
    }

    if (toDate) {
      const toTranslated = intl.messages["ECGS_FILTER.DATE.TO"] as string;
      dateText += ` ${toTranslated} ${moment(toDate).format(
        Constants.SECONDARY_DATE_FORMAT
      )}`.toUpperCase();
    }

    filtersDescription.push(dateText);
  }

  if (sn) {
    filtersDescription.push(`SN. ${sn}`);
  }

  if (unInterpretedOnly) {
    const unInterpretedOnlyTranslated = intl.messages[
      "ECGS_FILTER.UNINTERPRETED_ONLY"
    ] as string;

    filtersDescription.push(unInterpretedOnlyTranslated);
  }

  if (unviewedOnly) {
    const unviewedOnlyTranslated = intl.messages[
      "ECGS_FILTER.UNVIEWED_ECG"
    ] as string;

    filtersDescription.push(unviewedOnlyTranslated);
  }

  if (includeArchived) {
    const includeArchivedTranslated = intl.messages[
      "ECGS_FILTER.INCLUDE_ARCHIVED_ECG"
    ] as string;

    filtersDescription.push(includeArchivedTranslated);
  }

  if (reviewPriorityHigh || reviewPriorityLow || reviewPriorityNone) {
    const priorityTranslated = intl.messages[
      "USER.ECG.REVIEW_PRIORITY"
    ] as string;

    if (reviewPriorityHigh) {
      const highPriorityTranslated = intl.messages[
        "ECG_DETAILS.HIGH_PRIORITY"
      ] as string;
      filtersDescription.push(
        `${priorityTranslated} ${highPriorityTranslated}`
      );
    } else if (reviewPriorityLow) {
      const lowPriorityTranslated = intl.messages[
        "ECG_DETAILS.LOW_PRIORITY"
      ] as string;
      filtersDescription.push(`${priorityTranslated} ${lowPriorityTranslated}`);
    } else if (reviewPriorityNone) {
      const noPriorityTranslated = intl.messages["GLOBAL.NONE"] as string;
      filtersDescription.push(`${priorityTranslated} ${noPriorityTranslated}`);
    }
  }

  return (
    <p className={`m-0 px-3 pt-2 font-md font-weight-bold ${styles.text}`}>
      {filtersDescription.map((desc, index) =>
        index !== filtersDescription.length - 1 ? (
          <span>{desc} |&nbsp;</span>
        ) : (
          <span>{desc}</span>
        )
      )}
    </p>
  );
};

export default FiltersDescription;
